<template>
  <div style="padding: 5px">
    <div class="operators">
      <header>
        <h2>{{ $t('order_operators.title') }}</h2>
        <a-space>
          <a-button type="primary" @click="getOperatorsList">{{ $t('buttons.search') }}</a-button>
          <a-button
            type="primary"
            @click="visible = true; title=$t('order_operators.add')"
          >{{ $t('buttons.add') }}</a-button>
        </a-space>
      </header>
      <a-table
        childrenColumnName="assistant"
        :columns="columns"
        :data-source="data"
        :row-key="record => record.userTeamId"
        :loading="isLoading"
        :expanded-row-keys.sync="expandedRowKeys"
      >
        <template v-slot:detailsName="text">
          <text-highlight :queries="highLightInfo.userName">{{ text }}</text-highlight>
        </template>
        <template #operation="_, record">
          <a-button
            type="link"
            style="padding-left: 0"
            v-if="!record.parentUserId"
            @click="insertHelper(record)"
          >{{ $t('buttons.add') }}</a-button>
          <a-button
            type="link"
            style="padding-left: 0"
            :loading="record.loading"
            @click="toEdit(record)"
          >{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="deleteO(record)"
          >
            <a-button style="padding-left: 0" type="link" :loading="record.isDeleting">{{ $t('buttons.delete') }}</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <a-modal v-model="visible" :title="title" :afterClose="clearForm" @ok="submitForm">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :key="editedUserTeamId"
      >
        <a-form-model-item :label="$t('user.columns.role')" required>
          <a-select v-model="role" @change="handleRoleChange">
            <a-select-option value="receiver">{{ $t('orders.receiver') }}</a-select-option>
            <a-select-option value="helper">{{ $t('orders.helper') }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('orders.receiver')" :required="role === 'helper'" prop="parentUserId" v-show="role ==='helper'">
          <a-select v-model="form.parentUserId">
            <a-select-option v-for="d in data" :key="d.userId">
              {{ d.userName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('common.user')" prop="userId">
          <a-select
            v-model="form.userId"
            show-search
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            @inputKeydown="searchUser"
            @popupScroll="handleUserPopupScroll"
          >
            <a-select-option @click.native="selectUser(u)" v-for="u in users" :key="u.id">
              {{ u.realName }} - {{ u.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('order_operators.integral')" prop="ratio">
          <a-input v-model="form.ratio" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  searchReceiver,
  addOperator,
  deleteOperator
} from '@/api/operator'
import { searchUserList } from '@/api/auth/user'
import TextHighlight from "vue-text-highlight";
import moment from 'moment'

export default {
  components: { TextHighlight },
  data() {
    return {
      role: 'receiver',
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      highLightInfo: {
        userName: ""
      },
      params: {
        userName: ''
      },
      expandedRowKeys: [],
      data: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      visible: false,
      isLoading: false,
      title: '',
      editedUserTeamId: '',
      columns: [
        {
          title: () => (
            <div>
              { this.$t('order_operators.name') }
              <a-input class="search" allow-clear type="text" data-index="0" />
            </div>
          ),
          dataIndex: "userName",
          key: "userName",
          scopedSlots: {
            customRender: "detailsName"
          }
        },
        {
          title: () => this.$t('user.columns.mobile'),
          dataIndex: "phone",
          key: "phone"
        },
        {
          title: () => this.$t('user.columns.organization'),
          dataIndex: "organizationName",
          key: "organizationName"
        },
        // {
        //   title: '父级角色',
        //   dataIndex: 'pid',
        //   key: 'pid',
        //   scopedSlots: {
        //     customRender: 'pid'
        //   }
        // },
        {
          title: () => this.$t('order_operators.integral'),
          dataIndex: "ratio",
          key: "ratio"
        },
        {
          title: () => this.$t('common.createdAt'),
          dataIndex: "createdAt",
          key: "createdAt"
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: "operation",
          key: "operation",
          align: "left",
          scopedSlots: { customRender: "operation" }
        }
      ],
      form: {
        userId: '',
        ratio: '',
        parentUserId: 0,
        userName: ''
      },
      rules: {
        userId: [
          {
            required: true,
            message: this.$t('order_operators.su')
          }
        ],
        ratio: [
          {
            required: true,
            message: this.$t('order_operators.ei'),
            trigger: "blur"
          }
        ],
        parentUserId: [
          {
            validator: this.validateParentUserId,
            message: this.$t('order_operators.sr')
          }
        ]
      },
      authorities: [],
      users: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.getOperatorsList()
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  async mounted() {
    const ips = document.querySelectorAll(".search .ant-input");
    ips.forEach(ip => {
      ip.addEventListener("keyup", ({ key, target }) => {
        // console.log(key, target.value.trim())
        if (key === "Enter") {
          target.value = target.value.trim()
          // target.value.trim() && this.handleSearch()
          this.params.userName = target.value
          this.getOperatorsList();
        }
      });
      ip.addEventListener('blur', ({ target }) => {
        this.params.userName = target.value = target.value.trim()
      })
    });
  },
  methods: {
    translate() {
      this.rules = {
        userId: [
          {
            required: true,
            message: this.$t('order_operators.su')
          }
        ],
        ratio: [
          {
            required: true,
            message: this.$t('order_operators.ei'),
            trigger: "blur"
          }
        ],
        parentUserId: [
          {
            validator: this.validateParentUserId,
            message: this.$t('order_operators.sr')
          }
        ]
      }
    },
    validateParentUserId(_, value, callback) {
      console.log(this.role);
      if (this.role === 'receiver' || value) {
        callback()
      } else {
        callback(new Error(this.$t('order_operators.sr')))
      }
    },
    async getOperatorsList() {
      this.isLoading = true;
      try {
        const { data } = await searchReceiver(
          this.params
        );
        // this.data = data.records
        // .map(item => {
        //   // this.pids[item.id] = item.details[1].name
        //   item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
        //   item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
        //   return item
        // })
        this.expandedRowKeys = []
        for (let i = 0; i < data?.length || 0; i++) {
          if (data[i].createdAt) {
            data[i].createdAt = moment(data[i].createdAt).format('YYYY-MM-DD HH:mm:ss')
          }
          this.setTreeData(data[i])
        }
        this.data = data;
        this.$nextTick(() => {
          if (this.params.userName.trim()) {
            this.expandedRowKeys = data.map(d => d.userTeamId)
            this.highLightInfo.userName = this.params.userName.trim()
          } else {
            this.highLightInfo.userName = ''
          }
        })
      } finally {
        this.isLoading = false;
      }
    },
    selectUser(v) {
      this.form.userId = v.id
      this.form.userName = v.realName
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            let p
            if (this.form.parentUserId) {
              let pa = this.data.find(d => d.userId === this.form.parentUserId)
              let assistant = (pa?.assistant || [])
              pa = {
                parentUserId: pa.parentUserId,
                ratio: pa.ratio,
                userId: pa.userId,
                userName: pa.userName
              }
              let r = assistant.findIndex(a => a.userTeamId === this.editedUserTeamId)
              assistant = assistant.map(a => {
                return {
                  parentUserId: a.parentUserId,
                  ratio: a.ratio,
                  userId: a.userId,
                  userName: a.userName
                }
              })
              if (assistant?.length) {
                p = [pa, ...assistant]
              } else {
                p = [pa]
              }
              if (r >= 0) {
                p[r + 1] = this.form
              } else {
                p.push(this.form)
              }
            } else {
              p = [this.form]
              const pa = this.data.find(d => d.userTeamId === this.editedUserTeamId)
              if (pa) {
                if (pa.assistant?.length) {
                  p = [...p, ...pa.assistant.map(a => {
                    return {
                      parentUserId: a.parentUserId,
                      ratio: a.ratio,
                      userId: a.userId,
                      userName: a.userName
                    }
                  })]
                }
              }
            }
            const { message } = await addOperator(p)
            this.$message.success(message)
            this.getOperatorsList()
            this.clearForm()
          } catch (e) {
            console.log(e);
          }
        } else {
          this.$message.warn(this.$t('order_operators.failedValid'));
        }
      });
    },
    async showEditModal(record) {
      this.state = "edit";
      const { data } = await getRole(record.id);
      const c = [];
      this.menu = data.menus
      data.menus.forEach(item => {
        if (item.id) {
          if (item.pid === 0 && ![7].includes(item.id)) {
            return;
          }
          if ([17, 46].includes(item.id)) {
            c.push(item.id);
          } else {
            if (item.authorities && item.authorities.length > 0) {
              if (item.authorities.length === 4) {
                c.push(item.id);
              }
              item.authorities.forEach(a => {
                c.push(item.id + "-" + a.id);
              });
            } else {
              c.push(item.id);
            }
          }
        }
      });
      this.checkedKeys = c;
      this.c = [...c]
      console.log(c);
      this.title = this.$t('order_operators.editRole');
      record.details.forEach(d => {
        record[d.locale] = d.name;
      });
      console.log(record.details);
      if (!record["zh-CN"]) {
        record["zh-CN"] = record["en-US"];
      }
      if (!record.menus) {
        record.menus = [];
      }
      for (let key in this.form) {
        if (key === "pid") {
          this.form[key] = record[key] + "";
        } else {
          this.form[key] = record[key];
        }
      }
      this.selectedDeviceTypeList = record.allowSelectDeviceType.split(',')
      this.form.id = record.id;
      this.visible = true;
    },
    clearForm() {
      this.visible = false;
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
      this.role = 'receiver'
      this.form = {
        userId: '',
        ratio: '',
        parentUserId: 0,
        userName: ''
      };
      this.users = []
      this.editedUserTeamId = ''
    },
    insertHelper(r) {
      this.title = this.$t('order_operators.addHelper')
      this.form.parentUserId = r.userId
      this.role = 'helper'
      this.visible = true
    },
    async toEdit(r) {
      r.loading = true
      if (r.parentUserId) {
        this.role = 'helper'
        this.title = this.$t('order_operators.editHelper')
        this.form.parentUserId = r.parentUserId
      } else {
        this.title = this.$t('order_operators.editReciver')
        this.role = 'receiver'
      }
      this.form.userId = r.userId
      this.form.ratio = r.ratio
      this.form.userName = r.userName
      this.editedUserTeamId = r.userTeamId
      try {
        const { data } = await searchUserList(1, 10, {
          query: [],
          filter: [
            {
              field: 'id',
              value: r.userId
            }
          ],
          sort: []
        })
        this.users = data.records
      } catch(e) {
        console.log(e)
      } finally {
        r.loading = false
        this.visible = true
      }
    },
    setTreeData(item) {
      if (item.createdAt) {
        item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      }
      if (item.assistant && item.assistant.length) {
        for (let i = 0; i < item.assistant.length; i++) {
          this.setTreeData(item.assistant[i]);
        }
      } else {
        item.assistant = null;
      }
    },
    async searchUser(e) {
      if (e.code === 'Enter') {
        e.target.value = e.target.value.trim()
        this.userPage = 1
        this.uSearchFlag = true
        this.u = e.target.value
        const { data } = await searchUserList(1, 10, {
          query: [
            {
              field: 'realName',
              value: e.target.value
            }
          ],
          filter: [],
          sort: []
        })
        this.users = data.records
      }
    },
    async handleUserPopupScroll(e) {
      if (this.uSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if (scrollHeight - scrollTop === clientHeight) {
          this.userPage++
          const { data } = await searchUserList(this.userPage, 10, {
            query: [
              {
                field: 'realName',
                value: this.u
              }
            ],
            filter: [],
            sort: []
          })
          this.users = this.users.concat(data.records)
          if (this.users.length >= data.total) {
            this.uSearchFlag = false
          }
        }
      }
    },
    handleRoleChange(v) {
      if (v === 'helper') {
        this.form.parentUserId = undefined
      } else {
        this.form.parentUserId = 0
      }
    },
    async deleteO(r) {
      if (r.userTeamId) {
        r.isDeleting = true
        try {
          const { message } = await deleteOperator({
            userTeamId: r.userTeamId
          })
          this.$message.success(message)
          this.getOperatorsList()
        } catch(e) {
          console.log(e)
        } finally {
          r.isDeleting = false
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.operators {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-modal-body {
  padding-right: 50px;
}
</style>